import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError, delay, Observable, of, switchMap, throwError } from 'rxjs';
import { DocumentLibraryConstants } from '../document-library-constants';
import { DocumentSourceFileDetails } from '../models/documentSourceFileDetails';
import { DocumentSourceFileDTO } from '../models/documentSourceFileDTO';
import { DocumentSourceFileEdit } from '../models/documentSourceFileEdit';
import { DocumentPersistenceService } from '../services/document-persistence.service';
import { DocumentService } from '../services/document.service';

@Component({
  selector: 'app-document-file-checkin',
  templateUrl: './document-file-checkin.component.html',
  styleUrls: ['./document-file-checkin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentFileCheckinComponent implements OnInit {
 
  maxFileSize = DocumentLibraryConstants.Document_File_Max_Size;
  savedFiles: string[] = [];
  files: File[] = [];
  isUpload: boolean = false;
  fileName!: string;
  fileType!: string;
  isTemplate: boolean = false;
  isNoTemplate: boolean = true;
  templateId!: string;
  uploadedSourceFiles: File[] = [];
  documentSourceFileId!: string;
  documentSourceFile!:DocumentSourceFileEdit;
  documentVersionTitle?: string;
  fileNamesForAddAndDeleteOperations: string[] = [];
  @Output() isFileCheckInModalVisible=new EventEmitter<boolean>();
  documentSourceFileDetails!: DocumentSourceFileDTO;
  @Input() documentNumber!: any;
  @Input() documentVersion!: any;
  @Input()documentDetails!:any;
  errorMessages: string[] = [];
  disableFileUploader!:any;
  documentErrorReminder: string = DocumentLibraryConstants.Document_ErrorText;
  maxFileLimit = DocumentLibraryConstants.Document_Template_File_Max_Limit;
  fileCheckInLabelText:string=DocumentLibraryConstants.File_Check_In_Message;
  disableCheckInButton:boolean=true;
  showLoader:boolean = false;

  constructor(private documentService: DocumentService,
    private documentPersistenceService: DocumentPersistenceService,
    private documentsservice: DocumentService,
    private messageService: MessageService
    ) { }

  ngOnInit(): void {
  }

  display: boolean = true;

uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
  this.files = [...this.files, ...uploadedFiles];
  
  uploadedFiles.forEach((file) => {
    this.fileNamesForAddAndDeleteOperations.push(file.name);
  });

  const fileNames = uploadedFiles.map((file) => file.name);
  
  this.isUpload = true;
  this.disableFileUploader = true;
  this.fileName = fileNames[0];

  // Check if there are files to determine button state
  this.disableCheckInButton = this.files.length === 0;

  // Return an observable that immediately emits the fileNames array
  return of(fileNames);
};


  deleteFile = (fileName: string): Observable<boolean> => {
    this.deleteAttachment(fileName);
    this.isUpload=false;
    this.disableFileUploader=false;
    this.fileName='';
     var removedFile= of(true);
     if(this.files.length>0)
     {
       this.disableCheckInButton=false;
     }
     else
     {
       this.disableCheckInButton=true;
     }
     return removedFile;
  };

  private deleteAttachment = (fileNameToDelete: string) => {
    this.files = this.files.filter((file) => {
      return file.name != fileNameToDelete;
    });
    this.fileNamesForAddAndDeleteOperations =
      this.fileNamesForAddAndDeleteOperations.filter((fileName) => {
        return fileName != fileNameToDelete;
      });
  };

  checkInFileForDocument(event: any): void {
    this.disableCheckInButton = true;

      this.showLoader = true; // Show loader before making the HTTP call
      this.documentVersionTitle = this.documentDetails.title;

      this.documentService.getDocumentSourceFile(this.documentNumber, this.documentVersion)
        .subscribe({
          next: (docSourceFile) => {
            this.documentSourceFileId = docSourceFile!== null ? docSourceFile.documentSourceFileId : null;
            this.prepareDocumentSourceFile();
            this.updateDocumentSourceFile();
          },
          error: (error) => {
            if (error.status === 401) {
              this.messageService.add({
                severity: 'error', // Adjust based on your severity constants
                summary: `${error.error}`,
              });
            }
            else{
            const validationMessage = DocumentLibraryConstants.File_Upload_Failed.replace(
            'Name',DocumentLibraryConstants.DocumentSourceFile
          );
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: validationMessage,
            sticky:true
          })
            }
            this.showLoader = false;
          },
          complete: () => {
            this.showLoader = false; // Hide loader when request completes
          }
        });
  }


  reloadDocumentDetail(){
    this.isFileCheckInModalVisible.emit(false);
    this.disableFileUploader=false;
  }

  prepareDocumentSourceFile() {
    this.documentSourceFileDetails = {
      isTemplate: this.isTemplate,
      isNoTemplate: this.isNoTemplate,
      templateId: this.templateId,
      uploadedSourceFile: this.files[0],
      fileType: this.fileType,
      documentSourceFileId: this.documentSourceFileId,
    };
    this.documentPersistenceService.updateSourceFileDetails(
      this.documentSourceFileDetails
    );
  }


  updateDocumentSourceFile() {
    if (this.documentSourceFileDetails.isNoTemplate) {
      var fileName = this.documentSourceFileDetails.uploadedSourceFile.name;
      this.showLoader = true; // Assuming showLoader is a boolean flag to indicate loading state
  
      this.documentService.uploadFile(this.documentSourceFileDetails.uploadedSourceFile, DocumentLibraryConstants.DocumentTemplate_UploadFolder)
        .pipe(
          switchMap((response) => {
            let documentSourceFileDetail: DocumentSourceFileDetails = {
              isTemplate: false,
              templateId: null,
              uploadedFileType: response.fileExtension,
              uploadedFileId: response.fileId,
              uploadedFilePath: response.filePath,
              uploadedFileName: fileName,
              documentSourceFileId: this.documentSourceFileId,
              sourceFileName: this.documentPersistenceService.constructDocumentSourceFileTitle(this.documentNumber, this.documentVersion, this.documentVersionTitle!)
            };
            return this.documentService.updateDocumentSourceFile(documentSourceFileDetail, this.documentNumber, this.documentVersion);
          }),
          switchMap((documentSourceFileResponse) => {
            this.documentSourceFile = documentSourceFileResponse;
            return this.documentsservice.discardDocumentCheckoutInfo(this.documentNumber, Number(this.documentVersion));
          }),
          catchError((err) => {
            this.messageService.add({
              severity: DocumentLibraryConstants.Severity_Err,
              summary: `${err.error}`,
            });
            this.showLoader = false;
            return throwError(() => err);
          })
        )
        .subscribe((serviceData) => {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Success,
            summary: `${DocumentLibraryConstants.SourceFileCheckIn_Success}`,
          });
          setTimeout(() => {
            this.reloadDocumentDetail();
            this.showLoader = false;
          }, 2000);
        });
    }
  }
}
